(function () {
  const teamData = document.getElementById('pjs-teams')
  const teams = teamData ? JSON.parse(teamData.textContent) : []
  const overlay = document.getElementById('tf-overlay')
  const panel = document.getElementById('tf-panel')
  const input = document.getElementById('tf-input')
  const list = document.getElementById('tf-list')
  const empty = document.getElementById('tf-empty')
  if (!overlay || !teams.length) return
  input.placeholder = 'Search teams…'

  let idx = -1
  let shown = []
  function esc (text) {
    return text.replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]
    })
  }
  function mark (name, query) {
    if (!query) return esc(name)
    const i = name.toLowerCase().indexOf(query)
    if (i < 0) return esc(name)
    return (
      esc(name.slice(0, i)) +
      '<mark>' +
      esc(name.slice(i, i + query.length)) +
      '</mark>' +
      esc(name.slice(i + query.length))
    )
  }
  function render () {
    const query = input.value.trim().toLowerCase()
    shown = query
      ? teams.filter(function (team) {
        return team.n.toLowerCase().indexOf(query) > -1
      })
      : teams.slice()
    idx = shown.length ? 0 : -1
    if (!shown.length) {
      list.innerHTML = ''
      empty.hidden = false
      empty.innerHTML =
        'No team matches <b>' + esc(input.value.trim()) + '</b>. Try the city or the club name.'
      return
    }
    empty.hidden = true
    let html = ''
    let lastLg = null
    shown.forEach(function (team, i) {
      if (!query && team.l !== lastLg) {
        html += '<div class="grp">' + esc(team.l) + '</div>'
        lastLg = team.l
      }
      html +=
        '<a role="option" href="' +
        esc(team.u) +
        '" data-i="' +
        i +
        '"' +
        (i === 0 ? ' class="is-active" aria-selected="true"' : '') +
        '>' +
        '<span class="icon">' +
        (team.i
          ? '<img src="' +
            esc(team.i) +
            '" alt="" width="26" height="26" loading="lazy" decoding="async">'
          : esc(team.n.slice(0, 1))) +
        '</span>' +
        '<span class="team-name">' +
        mark(team.n, query) +
        '</span>' +
        (query ? '<span class="league">' + esc(team.l) + '</span>' : '') +
        '</a>'
    })
    list.innerHTML = html
    list.scrollTop = 0
  }
  function move (dir) {
    const items = list.querySelectorAll('a')
    if (!items.length) return
    items[idx] && items[idx].classList.remove('is-active')
    items[idx] && items[idx].removeAttribute('aria-selected')
    idx = (idx + dir + items.length) % items.length
    items[idx].classList.add('is-active')
    items[idx].setAttribute('aria-selected', 'true')
    const itemBox = items[idx].getBoundingClientRect()
    const listBox = list.getBoundingClientRect()
    if (itemBox.bottom > listBox.bottom) list.scrollTop += itemBox.bottom - listBox.bottom
    if (itemBox.top < listBox.top) list.scrollTop -= listBox.top - itemBox.top
  }
  let lastFocus = null
  function open () {
    lastFocus = document.activeElement
    overlay.hidden = false
    overlay.classList.add('is-open')
    document.documentElement.style.overflow = 'hidden'
    input.value = ''
    render()
    setTimeout(function () {
      input.focus()
    }, 30)
  }
  function close () {
    overlay.classList.remove('is-open')
    overlay.hidden = true
    document.documentElement.style.overflow = ''
    if (lastFocus && lastFocus.focus) lastFocus.focus()
  }
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-team-finder-open], a[href$="#team-finder"]')
    if (!trigger) return
    e.preventDefault()
    open()
  })
  overlay.addEventListener('click', function (e) {
    if (!panel.contains(e.target)) close()
  })
  const closeBtn = document.getElementById('tf-close')
  if (closeBtn) closeBtn.addEventListener('click', close)
  input.addEventListener('input', render)
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      move(1)
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      move(-1)
    } else if (e.key === 'Enter') {
      const a = list.querySelectorAll('a')[idx]
      if (a) {
        e.preventDefault()
        window.location.href = a.getAttribute('href')
      }
    } else if (e.key === 'Escape') {
      e.preventDefault()
      close()
    }
  })
  document.addEventListener('keydown', function (e) {
    const a = document.activeElement || {}
    const typing = /input|textarea|select/i.test(a.tagName || '') || a.isContentEditable
    if (overlay.classList.contains('is-open')) return
    if (!typing && (e.key === 't' || e.key === 'T')) {
      e.preventDefault()
      open()
    }
  })
})()
